import React from 'react';
import { RouteConfig } from 'react-router-config';

import { PageRouteType, routePostProc } from '@/util/route';

const AgentCenter = React.lazy(
  () => import('@/page/app/smart-construction/agent-center/agent-center-list')
);

const AgentCreate = React.lazy(
  () => import('@/page/app/smart-construction/agent-center/agent-create')
);

const AgentAccess = React.lazy(
  () => import('@/page/app/smart-construction/agent-center/agent-access')
);

const AgentUpdate = React.lazy(
  () => import('@/page/app/smart-construction/agent-center/agent-update')
);

const AgentEvaluation = React.lazy(
  () => import('@/page/app/smart-construction/agent-center/agent-evaluation')
);

const PluginCenter = React.lazy(
  () => import('@/page/app/smart-construction/plugin-center')
);

const LogAnalysis = React.lazy(
  () => import('@/page/app/smart-construction/loganalysis')
);

// 增加日志分析
const LogDetail = React.lazy(
  () => import('@/page/app/smart-construction/loganalysis/log-detail')
);

const SMART_CONSTRUCTION_ROUTE: RouteConfig[] = [
  {
    path: '/agentCreate',
    component: AgentCreate,
  },
  {
    path: '/agentAccess',
    component: AgentAccess,
  },
  {
    path: '/agentDetail',
    component: AgentUpdate,
  },
  {
    path: '/agentEvaluation',
    component: AgentEvaluation,
  },
  {
    path: '/agentCenter',
    component: AgentCenter,
  },
  {
    path: '/pluginCenter',
    component: PluginCenter,
  },
  {
    path: '/loganalysis',
    exact: true,
    component: LogAnalysis,
  },
  {
    path: '/loganalysis/detail',
    component: LogDetail,
  },
];

export { SMART_CONSTRUCTION_ROUTE };
export default routePostProc(
  PageRouteType.SMART_CONSTRUCTION,
  SMART_CONSTRUCTION_ROUTE
);
